module.exports = __webpack_public_path__ + "img/kid.60760c71.svg";